import React from 'react';
import { DocIcon, isDefaultDocIcon } from '../../../../../../../Sidebar/icons';
import { renderIcon } from '../../../../../utils/renderIcon';

const isAppIcon = (icon) =>
  icon && typeof icon === 'object' && (icon.type === 'fontawesome' || icon.type === 'custom');

/**
 * Same glyph rules as Documents (sidebar / browse / atlas): default 📄
 * becomes the gradient page mark; custom emoji / FA / uploads stay as-is.
 */
const AttachedDocMark = ({ icon, size = 16 }) => {
  if (isDefaultDocIcon(icon)) return <DocIcon size={size} />;
  if (isAppIcon(icon)) {
    return renderIcon(icon, { size: `${size}px`, fallback: <DocIcon size={size} /> });
  }
  if (typeof icon === 'object' && icon.type === 'emoji' && icon.value) {
    return <span aria-hidden>{icon.value}</span>;
  }
  if (typeof icon === 'string') {
    return <span aria-hidden>{icon}</span>;
  }
  return <DocIcon size={size} />;
};

export default AttachedDocMark;
